import routes from "constants/routes";
import { tokenUtils } from "utils";

export const isAuthenticated = () => tokenUtils.isValidUser();

export const logout = () => {
  tokenUtils.deleteToken();
};

export const clearInvalidSession = () => {
  if (!tokenUtils.isValidUser() && tokenUtils.getToken()) {
    tokenUtils.deleteToken();
  }
};

export const isLoginPath = (pathname) => pathname === routes.login.root;

const isRootPath = (path) => path === "/";

export const isSafeAppRedirectPath = (path) => {
  const normalizedPath = String(path ?? "").trim();

  if (
    normalizedPath === "" ||
    normalizedPath === routes.login.root ||
    isRootPath(normalizedPath)
  ) {
    return false;
  }

  if (!normalizedPath.startsWith("/")) {
    return false;
  }

  if (normalizedPath.startsWith("//")) {
    return false;
  }

  if (normalizedPath.includes("://")) {
    return false;
  }

  return true;
};

export const isProtectedPath = (pathname) => isSafeAppRedirectPath(pathname);

export const buildRedirectTarget = (pathname = "", search = "") =>
  `${pathname}${search}`;

export const getLoginPathWithRedirect = (redirectTarget = "") => {
  const normalizedRedirectTarget = String(redirectTarget ?? "").trim();

  if (!isSafeAppRedirectPath(normalizedRedirectTarget)) {
    return routes.login.root;
  }

  return `${routes.login.root}?redirect=${encodeURIComponent(normalizedRedirectTarget)}`;
};

export const getPostLoginRedirectPath = (search = "") => {
  const redirectPath = new URLSearchParams(search).get("redirect");

  if (redirectPath !== null && isSafeAppRedirectPath(redirectPath)) {
    return redirectPath;
  }

  return routes.coupons.list;
};
